import get from 'lodash/get';
import { getAssets } from './getAssets';
import {
  Body,
  CategoryData,
  ValueLessHeaderId,
  Liquidity,
  LiquidityKeys,
  EstateKeys,
} from '../FlowTable.meta';

interface GetLiquidityParams {
  data: CategoryData;
  accumulator: Body;
  liquidityKey: LiquidityKeys;
  estateKey: EstateKeys;
}

export const getLiquidity = ({
  data,
  accumulator,
  liquidityKey,
  estateKey,
}: GetLiquidityParams): Liquidity => {
  return {
    ...get(accumulator, [estateKey, liquidityKey], {}),

    name: get(data, [estateKey, liquidityKey, 'liquidIlliquidTypeText'], null) ?? '',
    id: get(data, [estateKey, liquidityKey, 'liquidIlliquidType'], null) ?? 0,

    totals: [
      ...get(accumulator, [estateKey, liquidityKey, 'totals'], []),
      ...(data.headerId !== ValueLessHeaderId.Summary
        ? [
            {
              headerId: data.headerId,
              collapsed: data.collapsed,
              value: get(data, [estateKey, liquidityKey, 'total'], null),
              headerName: data.headerName,
            },
          ]
        : []),
    ],

    assets: getAssets({
      data,
      estateKey,
      liquidityKey,
      defaultValue: get(accumulator, [estateKey, liquidityKey, 'assets'], {}),
    }),
  };
};
